import { useEffect, useRef, useState } from 'react';

export function useSwiperAutoplayFix(slides) {
  const swiperRef = useRef();
  const [autoplay, setAutoplay] = useState(false);
  const shouldAutoplay = slides.length > 1;

  if (autoplay !== shouldAutoplay) setAutoplay(shouldAutoplay);

  useEffect(() => {
   
    if (autoplay) {
      const timer = setTimeout(() => {
      
        swiperRef.current?.autoplay.start();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [autoplay]);

  return swiperRef;
}
